import { render, staticRenderFns } from "./DropdownFilters.vue?vue&type=template&id=0af2a67e&scoped=true&"
import script from "./DropdownFilters.vue?vue&type=script&lang=js&"
export * from "./DropdownFilters.vue?vue&type=script&lang=js&"
import style0 from "./DropdownFilters.vue?vue&type=style&index=0&id=0af2a67e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2a67e",
  null
  
)

export default component.exports